import { wrapLazyRoute } from "../lazy-loading/lazyWrapper";
export const routes = () => {
	return [
		{
			path: "/backoffice/store/activation",
			component: wrapLazyRoute(() => import("sd_bo_ui/StoreActivationPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "storeActivation",
			},
		},
		{
			path: "/backoffice/search/synonyms",
			component: wrapLazyRoute(() => import("sd_bo_ui/SynonymsManagementPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "synonymsManagement",
			},
		},
		{
			path: "/backoffice/search/synonyms/edit",
			component: wrapLazyRoute(() => import("sd_bo_ui/SynonymEditingPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "synonymsManagementEdit",
			},
		},
		{
			path: "/backoffice/search/compare",
			component: wrapLazyRoute(() => import("sd_bo_ui/SearchComparisonPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "searchComparison",
			},
		},
		{
			path: "/backoffice/category/images",
			component: wrapLazyRoute(() => import("sd_bo_ui/CategoryConfigurationPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "categoryImagesSettings",
			},
		},
		{
			path: "/backoffice/category/images/choose/:CategoryId",
			component: wrapLazyRoute(() => import("sd_bo_ui/CategoryImagesChoosingPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "categoryImagesChoosing",
			},
		},
	];
};
